import {
    Button,
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useEffect, useMemo, useState } from "react";
import { singularizeLastWord } from "services/Crm/utils/calcUtils";
import CommonCheckTable from "./checktable";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";

const DynamicModel = (props) => {
    const { onClose, isOpen, id, title, isLoading, moduleData, isSingleSelectionOnly, isModelDataSubmitLoading, columns, onSubmitHandler, modalTitle, permission, selectedColumns, setSelectedColumns, data = [], setModalAction, modalAction, dataColumn, interestProperty, dynamicModule, tableData = [] } = props;
    const [selectedValues, setSelectedValues] = useState([]);
    const [currentPage, setCurrentPage] = useState(() => {
        const paginationState = JSON.parse(localStorage.getItem("paginationState"));
        return paginationState?.pageName === title && paginationState?.currentPage
            ? paginationState.currentPage
            : 1;
    });

    const [pageSize, setPageSize] = useState(() => {
        const paginationState = JSON.parse(localStorage.getItem("paginationState"));
        return paginationState?.pageName === title && paginationState?.pageSize
            ? paginationState.pageSize
            : 10;
    });
    const [metadata, setMetadata] = useState({});
    const [searchbox, setSearchbox] = useState(null);
    const filteredData = useMemo(() => {
        if (!searchbox) return data;
        const lowerSearch = searchbox.toLowerCase();
        return data?.filter((item) =>
            Object.values(item).some((val) =>
                val?.toString().toLowerCase().includes(lowerSearch)
            )
        );
    }, [data, searchbox]);

    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;
        return filteredData.slice(start, end);
    }, [filteredData, currentPage, pageSize]);


    useEffect(() => {
        setCurrentPage(1);
    }, [searchbox,]);

    useEffect(() => {
        const totalRecords = data?.length;
        const totalPages = Math.ceil(totalRecords / pageSize);

        setMetadata({
            totalRecords,
            totalPages,
        });

        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(1);
        }
    }, [data, pageSize, currentPage]);
    const handleSubmit = async () => {
        const added = selectedValues.filter(val => !initialCheckedValues.includes(val));
        const removed = initialCheckedValues.filter(val => !selectedValues.includes(val));

        const hasChanges = added.length > 0 || removed.length > 0;

        if (!hasChanges) return;

        const uniqueValues = [...new Set(selectedValues)];
        onSubmitHandler(uniqueValues, id, selectedValues);
    };

    const [initialCheckedValues, setInitialCheckedValues] = useState([]);

    useEffect(() => {
        if (isOpen && Array.isArray(tableData)) {
            const initialIds = tableData.map((item) => item._id);
            setInitialCheckedValues(initialIds);
            setSelectedValues(initialIds);
        }
    }, [isOpen]);

    const isSelectionUnchanged = () => {
        if (initialCheckedValues.length !== selectedValues.length) return false;

        const set1 = new Set(initialCheckedValues);
        const set2 = new Set(selectedValues);

        for (let val of set1) {
            if (!set2.has(val)) return false;
        }

        return true;
    };

    function onCloseHandler() {
        setSelectedValues([])
        onClose()
    }

    // useEffect(() => {
    //     if (Array.isArray(dynamicModule)) {
    //         setSelectedValues((prevSelectedValues) => [
    //             ...prevSelectedValues,
    //             ...dynamicModule,
    //         ]);
    //     }
    // }, [dynamicModule]);
    return (
        <Modal onClose={() => { onCloseHandler() }} isCentered isOpen={isOpen}>
            <ModalOverlay />
            <ModalContent maxW={"700px"}>
                <ModalHeader>{modalTitle}</ModalHeader>
                <ModalCloseButton />
                <ModalBody className="modalBody">
                    {isLoading ? (
                        <Flex justifyContent={"center"} alignItems={"center"} width="100%">
                            <Spinner />
                        </Flex>
                    ) : (
                        <CommonCheckTable
                            deleteMany={"true"}
                            isHideNavbarAction={false}
                            fullHeight={true}
                            title={singularizeLastWord(title)}
                            isLoading={isLoading}
                            viewData={moduleData}
                            columnData={columns}
                            onLinkClick={() => { }}
                            dataColumn={dataColumn}
                            allData={filteredData}
                            tableData={paginatedData}
                            tableCustomFields={
                                data?.[0]?.fields?.filter(
                                    (field) => field?.isTableField === true
                                ) || moduleData?.fields?.filter((field) => field?.isTableField) || []
                            }
                            access={permission}
                            action={modalAction}
                            setAction={setModalAction}
                            selectedColumns={selectedColumns}
                            setSelectedColumns={setSelectedColumns}
                            isOpen={isOpen}
                            onClose={() => { onCloseHandler() }}
                            selectedValues={selectedValues}
                            isSingleSelectionOnly={isSingleSelectionOnly}
                            setSelectedValues={setSelectedValues}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            metadata={metadata}
                            handleSearchChange={setSearchbox}
                            searchbox={searchbox}
                            setSearchbox={setSearchbox}
                            isPagination={false}
                        />
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        size="sm"
                        variant="brand"
                        onClick={handleSubmit}
                        disabled={
                            isModelDataSubmitLoading ||
                            (
                                (moduleData?.moduleName === "Deals" && title.toLowerCase() === "accounts" && selectedValues.length === 0)
                            ) ||
                            (data && data.length === 0) ||
                            isSelectionUnchanged()
                        }

                    >
                        {isModelDataSubmitLoading ? (
                            <Spinner
                                size={20}
                                paddingRight={5}
                                border={`3px solid ${globalStyles.colors.loaderBorder}`}
                                borderTop={`1px solid ${globalStyles.colors.transparent}`}
                            />
                        ) : (
                            ""
                        )}
                        {constant.save}
                    </Button>
                    <Button
                        size="sm"
                        sx={{
                            marginLeft: 2,
                            textTransform: "capitalize",
                        }}
                        variant="outline"
                        colorScheme="red"
                        onClick={() => onCloseHandler()}
                    >
                        {crmConstant.close}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DynamicModel;
